import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomerBundleItems, StateStatus } from '@guryou/redux';

const useCustomerBundleItems = ({ userBundleId }) => {
  const dispatch = useDispatch();
  const { data, status, version, entity, request } = useSelector(state => state.bundle.getCustomerItems);
  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED || (status === StateStatus.LOADED && request.id !== userBundleId)) {
      dispatch(getCustomerBundleItems(userBundleId));
    }
  }, [data, dispatch, request, status, userBundleId]);

  return { data: data || [], status, version, entity };
};

export default useCustomerBundleItems;
